import { useCallback, useState } from "react";

type UseConfirmation = {
  confirm(): Promise<boolean>;
  isConfirming: boolean;
  handleConfirmOk(): void;
  handleConfirmCancel(): void;
};

export function useConfirmation(isConfirmingInit = false): UseConfirmation {
  const [isConfirming, setIsConfirming] = useState(isConfirmingInit);
  const [resolve, setResolve] = useState<(value: boolean | PromiseLike<boolean>) => void>();

  const confirm = useCallback(() => {
    setIsConfirming(true);
    return new Promise<boolean>((_resolve) => {
      setResolve(() => _resolve);
    });
  }, [setResolve, setIsConfirming]);

  const handleConfirmOk = useCallback(() => {
    setIsConfirming(false);
    if (resolve) resolve(true);
  }, [resolve, setIsConfirming]);

  const handleConfirmCancel = useCallback(() => {
    setIsConfirming(false);
    if (resolve) resolve(false);
  }, [resolve, setIsConfirming]);

  return {
    confirm,
    isConfirming,
    handleConfirmOk,
    handleConfirmCancel,
  };
}

export default useConfirmation;
